import React from 'react';

const FileUploader = ({ onDataLoaded }) => {
  const parseOLEDData = (text) => {
    const lines = text.split('\n').filter(line => line.trim());
    const data = [];
    
    // Пропускаємо заголовок
    for (let i = 1; i < lines.length; i++) {
      const line = lines[i].trim();
      if (!line) continue;
      
      // Парсимо формат: "1.0000V   -2.440nA   -3.646nA"
      const parts = line.split(/\s+/);
      if (parts.length < 3) continue;
      
      const voltage = parseFloat(parts[0].replace('V', ''));
      const current1 = parseCurrentValue(parts[1]);
      const current2 = parseCurrentValue(parts[2]);
      
      data.push({
        voltage,
        current1,
        current2
      });
    }
    
    return data;
  };
  
  const parseCurrentValue = (str) => {
    // Парсимо формати: "1.716mA", "36.14uA", "-3.699nA", "861.5pA"
    const num = parseFloat(str);
    if (str.includes('mA')) return num * 1e-3;
    if (str.includes('uA')) return num * 1e-6;
    if (str.includes('nA')) return num * 1e-9;
    if (str.includes('pA')) return num * 1e-12;
    return num;
  };
  
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const text = e.target.result;
        const data = parseOLEDData(text);
        console.log('📁 File loaded, parsed data points:', data.length);
        console.log('📊 Sample data:', data.slice(0, 3));
        onDataLoaded(data);
      } catch (error) {
        console.error('Помилка парсингу:', error);
        alert('Помилка читання файлу. Переконайтесь що формат правильний.');
      }
    };
    reader.readAsText(file);
  };
  
  return (
    <div style={{
      margin: '20px 0',
      padding: '20px',
      background: '#f0f8ff',
      borderRadius: '8px',
      border: '2px dashed #2196f3'
    }}>
      <h4 style={{ marginTop: 0 }}>📁 Завантажити дані з файлу</h4>
      <p style={{ fontSize: '14px', color: '#666' }}>
        Підтримується формат з вольтметра/амперметра (V1, Ch1, Ch2)
      </p>
      <input 
        type="file" 
        accept=".txt,.csv"
        onChange={handleFileUpload}
        style={{
          padding: '10px',
          fontSize: '14px',
          cursor: 'pointer'
        }}
      />
    </div>
  );
};

export default FileUploader;
